// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"624f8742","182":"712d994f","226":"29357437","353":"142ddae7","466":"09207513","514":"f0a0a30d","549":"b7a2d056","670":"eac6a584","802":"0123b872","984":"6169bacb"}[chunkId] + ".chunk.js";
};